import React from "react";
import { observer, inject } from "mobx-react";
import { STORE_CREATE_EDIT_CUSTOMER_ORDER, STORE_COMMON } from "../../../../constants";
import * as yup from 'yup';
import { Formik } from 'formik';
import { Form, Row, Col } from "react-bootstrap";

interface IProps {
    bindSubmitForm: (submit: () => Promise<any>) => void,
    id: string,
    firstName: string,
    middleName: string,
    lastName: string,
    phone: string,
    email: string,
    address: string,
    comment: string,
    saveCustomer: (
        firstName: string,
        middleName: string,
        lastName: string,
        phone: string,
        email: string,
        address: string,
        comment: string
    ) => void;
}
interface IState {
    id: string,
    firstName: string,
    middleName: string,
    lastName: string,
    phone: string,
    email: string,
    address: string,
    comment: string

}

const schema = yup.object({
    firstName: yup.string().required("Введите имя"),
    middleName: yup.string(),
    lastName: yup.string(),
    phone: yup.string().required("Введите телефон"),
    email: yup.string(),
    address: yup.string(),
    comment: yup.string()
});


@inject(STORE_COMMON, STORE_CREATE_EDIT_CUSTOMER_ORDER)
@observer
export class NewEditCustomerForm extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
    }

    render() {
        return <Formik
            validationSchema={schema}
            initialValues={this.props}

            onSubmit={(values, actions) => {
                this.props.saveCustomer(
                    values.firstName,
                    values.middleName,
                    values.lastName,
                    values.phone,
                    values.email,
                    values.address,
                    values.comment
                )
            }}
            render={(props) => {
                this.props.bindSubmitForm(props.submitForm)
                return <Form onSubmit={props.handleSubmit} >

                    <Form.Group as={Row} controlId="formPhone">
                        <Form.Label column sm={5}>
                            Телефон
                            </Form.Label>
                        <Col sm={7}>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="Укажите телефон..."
                                value={props.values.phone}
                                name="phone"
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.phone} />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.phone}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formLastName">
                        <Form.Label column sm={5}>
                            Фамилия
                            </Form.Label>
                        <Col sm={7}>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="Введите фамилию..."
                                value={props.values.lastName}
                                name="lastName"
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.lastName}
                            />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.lastName}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formName">
                        <Form.Label column sm={5}>
                            Имя
                            </Form.Label>
                        <Col sm={7}>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="Введите имя..."
                                value={props.values.firstName}
                                name="firstName"
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.firstName}
                            />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.firstName}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formMiddleName">
                        <Form.Label column sm={5}>
                            Отчество
                            </Form.Label>
                        <Col sm={7}>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="Введите отчество..."
                                value={props.values.middleName}
                                name="middleName"
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.middleName}
                            />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.middleName}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formEmail">
                        <Form.Label column sm={5}>
                            Email
                            </Form.Label>
                        <Col sm={7}>
                            <Form.Control size="sm" type="text" placeholder="Укажите email..." value={props.values.email}
                                name="email"
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.email} />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.email}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formAddress">
                        <Form.Label column sm={5}>
                            Адрес
                            </Form.Label>
                        <Col sm={7}>
                            <Form.Control size="sm" as="textarea"
                                placeholder="Укажите адрес..."
                                value={props.values.address}
                                name="address"
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.address} />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.address}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="formComment">
                        <Form.Label column sm={5}>
                            Комментарий
                            </Form.Label>
                        <Col sm={7}>
                            <Form.Control size="sm" as="textarea"
                                placeholder="Укажите комментарий..."
                                value={props.values.comment}
                                name="comment"
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.comment} />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.comment}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>


                </ Form>
            }} />
    }
}